import { isNotNull } from '@alice-financial/alice-sdk'
import { HeaderTitle, Link } from '@alice-financial/pretext-ui'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import * as React from 'react'
import { useParams } from 'react-router'
import { useCurrentOrgRootPath, useOrg } from './organization/useOrg'

const TitleLink = ({ to, children }: { to: string; children: React.ReactNode }) => (
  <Link to={to} sx={{ textDecoration: 'none' }}>
    {children}
  </Link>
)

export const OrgRouteTitle = () => {
  const orgRootPath = useCurrentOrgRootPath()
  const params = useParams()
  const org = useOrg()
  if (!org) return null
  const employer = params.employerId
    ? org.employers.filter(isNotNull).find((e) => e.id.toString() === params.employerId)
    : null

  if (employer) {
    return (
      <HeaderTitle>
        <TitleLink to={orgRootPath}>{org.name}</TitleLink>{' '}
        <ChevronRightIcon sx={{ vericalAlign: 'bottom' }} />{' '}
        <TitleLink to={`${orgRootPath}/employer/${employer.id}`}>{employer.name}</TitleLink>
      </HeaderTitle>
    )
  }
  return (
    <HeaderTitle>
      <TitleLink to={orgRootPath}>{org.name}</TitleLink>
    </HeaderTitle>
  )
}
